/**
 * @description parses the user settings and returns a list of quick links that can be displayed in the user menu of the
 *  application navigation bar
 */

import React from 'react';

import { UserSettingsContext } from '../contexts/userSettings';

const useUserMenuQuickLinks = () => {
  const userSettings = React.useContext(UserSettingsContext);

  const userLinks = React.useMemo(() => {
    const list = [];

    if (!userSettings) {
      return list;
    }

    list.push(...[
      {
        path: '/employee/faqs',
        label: 'Frequently Asked Questions'
      },
      {
        path: '/employee/index',
        label: 'My Employee Portal',
        reloadDocument: true
      },
      {
        path: '/privacyPolicy/index',
        label: 'Privacy Policy'
      },
      {
        path: '/knowledgeCenter/index',
        label: 'Knowledge Center'
      }
    ]);

    if (userSettings.userNavigation?.length) {
      list.push(
        ...userSettings.userNavigation.map((entry) => ({
          path: `/${ entry.path }`,
          label: entry.name,
          reloadDocument: true
        }))
      );
    }

    if (userSettings.systemAdminNavigation?.length) {
      // System Admin link should point to the user controller, when available. Otherwise point to the first entry in the list
      const sysAdminLink = userSettings.systemAdminNavigation.find((entry) => /UserController/.test(entry.controller)) ?? userSettings.systemAdminNavigation[0];

      list.push({
        path: `/${ sysAdminLink.path }`,
        label: 'System Admin',
        reloadDocument: true
      });
    }

    return list.sort((navA, navB) => navA.label.localeCompare(navB.label, 'en', { sensitivity: 'base' }));
  }, [userSettings]);

  return userLinks;
};

export default useUserMenuQuickLinks;
